import { render, staticRenderFns } from "./buySharePage.vue?vue&type=template&id=5e368c61&scoped=true&"
import script from "./buySharePage.vue?vue&type=script&lang=js&"
export * from "./buySharePage.vue?vue&type=script&lang=js&"
import style0 from "./buySharePage.vue?vue&type=style&index=0&id=5e368c61&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e368c61",
  null
  
)

export default component.exports